<template>
  <f-loader v-if="!me"></f-loader>

  <admin-dashboard 
    v-if="isAdmin || isInvest"
  ></admin-dashboard>

  <growth-dashboard 
    v-if="isGrowth"
  ></growth-dashboard>

  <span v-if="false"></span>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from '@freebe/sdk/store'
import useRoles from '@composables/use-roles'
import GrowthDashboard from './growth/growth-dashboard'
import AdminDashboard from './admin/admin-dashboard'
 
export default {
  setup() {
    const { me } = useStore('@admin/users')
    const { isGrowth, isAdmin, isInvest } = useRoles()

    return {
      me,
      isGrowth,
      isAdmin,
      isInvest,
    }
  },

  components: {
    AdminDashboard,
    GrowthDashboard,
  }
}
</script>
